
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_REQUEST,
    CHANGE_STATUS_CREATE_SCHEDULED_ACTION_REQUEST,
    CHANGE_STATUS_UPDATE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import {
    changeStatusSearchScheduledActionsResult,
    changeStatusCreateScheduledActionResult,
    changeStatusUpdateResult,
} from 'Redux/actions';


function* updateChange({ payload }) {
    try {
        const QUERY = `
            mutation updateUnitsBatch ($unitIds: [Int]!, $features: UnitFeatureInput!, $simProviderAccountId: Int, $companyId: Int, $status: Int, $reference: String) {
                result: updateUnitsBatch (unitIds: $unitIds, features: $features, simProviderAccountId: $simProviderAccountId, companyId: $companyId, status: $status, reference: $reference) {
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) yield put(changeStatusUpdateResult({ update: data?.result }))
        else yield put(changeStatusUpdateResult({ update: false }))

    } catch (exc) {
        yield put(changeStatusUpdateResult({ update: false, exc: exc.error }));
        ExceptionManager(
            exc,
            "Modules/devices/.components/changeStatus/redux/saga",
            "updateChange",
        )
    }
}

function* createScheduledAction({ payload }) {
    try {
        let QUERY = `
            mutation createScheduledAction ($scheduledActions: [ScheduledActionInput], $entityName: String!, $entities: [EntityInput!]) {
                result: createScheduledAction (scheduledActions: $scheduledActions, entityName: $entityName, entities: $entities)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(changeStatusCreateScheduledActionResult({ response: data.result }))

    } catch (exc) {
        yield put(changeStatusCreateScheduledActionResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/devices/.components/changeStatus/redux/saga', 'createScheduledAction');
    }
}

function* searchScheduledActions({ payload }) {
    try {
        let QUERY = `
            query searchScheduledActions ($conditions: [ScheduledActionSearchInput], $sort: [ScheduledActionSortInput], $limit: Int, $offset: Int) {
                result: searchScheduledActions (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        scheduleOn
                        data
                        entityName
                        entityId
                        executed
                        isDeleted
                        deletedOn
                        deletedBy
                        error
                    }
                    total
                }
            }
        `

        let data = yield call(
            clientQuery,
            QUERY,
            {
                "conditions": [
                    {
                        "fields": ["entityName"],
                        "terms": ["Unit"],
                        "exact": true
                    },
                    {
                        "fields": ["entityId"],
                        "terms": payload,
                        "exact": true
                    },
                    {
                        "fields": ["executed"],
                        "terms": [false],
                        "exact": true
                    }
                ],
                "sort": [{ "field": "scheduleOn", "order": "ASC" }],
                "limit": 1000,
                "offset": 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result
            yield put(changeStatusSearchScheduledActionsResult(items))
        } else {
            yield put(changeStatusSearchScheduledActionsResult([]))
        }

    } catch (exc) {
        yield put(changeStatusSearchScheduledActionsResult([]))
        ExceptionManager(exc, 'Modules/devices/.components/changeStatus/redux/saga', 'searchScheduledActions');
    }
}

function* watchMethods() {
    yield takeEvery(CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_REQUEST, searchScheduledActions);
    yield takeEvery(CHANGE_STATUS_CREATE_SCHEDULED_ACTION_REQUEST, createScheduledAction);
    yield takeEvery(CHANGE_STATUS_UPDATE_REQUEST, updateChange);

}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}